import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';

class DropDownTinhTrangXuLy extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.data != nextProps.data) {
      this.setState({
        data: nextProps.data
      });
    }
  }

  render() {
    return (
      <DropDown label="Tình trạng xử lý" options={ this.state.data } keyName='giaTri' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownTinhTrangXuLy.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: '--Chọn--'
  },
  options: []
}

let bindStateToProps = state => {
  return {
    
  }
}

export default connect(bindStateToProps)(DropDownTinhTrangXuLy);


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-tinhtrangxuly.jsx